import { createReducer, on } from '@ngrx/store';
import * as UserActions from './user.actions';
import { UserMeResponse } from '../../services/UserService';

export interface UserState {
  currentUserMeResponse: UserMeResponse | null;
  loading: boolean;
  error: any;
}

export const initialState: UserState = {
  currentUserMeResponse: null,
  loading: false,
  error: null,
};

export const userReducer = createReducer(
  initialState,
  
  // Load user me
  on(UserActions.loadUserMe, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  
  on(UserActions.loadUserMeSuccess, (state, { userMeResponse }) => ({
    ...state,
    currentUserMeResponse: userMeResponse,
    loading: false,
    error: null,
  })),
  
  on(UserActions.loadUserMeFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  
  // Clear user me
  on(UserActions.clearUserMe, (state) => ({
    ...state,
    currentUserMeResponse: null,
    loading: false,
    error: null,
  }))
);
